// =====================================================
// ẢNH ĐẠI DIỆN NÉT NHẤT — chuẩn bị ảnh trước khi tải lên (file riêng)
// File: web-app/src/utils/anhDaiDien.js
//
// Trước đây ảnh bị thu còn 512px nên bấm xem lớn bị mờ. Giờ gửi HAI ảnh:
//   - goc: GIỮ NGUYÊN độ phân giải gốc, JPEG chất lượng 0.95 (PNG giữ PNG), bỏ dữ liệu vị trí GPS ẩn trong ảnh.
//          Chỉ thu lại khi ảnh vượt sức vẽ của trình duyệt (iPhone: ~16 triệu điểm ảnh). Không vẽ được thì gửi nguyên tệp.
//   - nho: bản 320px cho các chỗ hiện nhỏ (đầu trang, chat, danh sách) để trang vẫn nhẹ.
// Máy chủ lưu bản nhỏ làm avatar_url, tên bản nhỏ mang đuôi "_nho_<đuôi gốc>.jpg" -> suy ra được ảnh gốc.
// =====================================================

const DIEM_TOI_DA = 16000000;   // giới hạn vùng vẽ an toàn trên iPhone (4096 x 4096)
const CANH_NHO = 320;
const CHAT_LUONG_GOC = 0.95;
const CHAT_LUONG_NHO = 0.9;

// Từ đường dẫn bản nhỏ suy ra ảnh gốc: ".../u5_17_ab_nho_jpg.jpg" -> ".../u5_17_ab.jpg". Ảnh kiểu cũ thì giữ nguyên.
export const anhGocTuNho = (url) => (url ? String(url).replace(/_nho_([a-z0-9]+)\.jpg(\?.*)?$/i, '.$1$2') : url);

const dongLai = (b) => { if (b && typeof b.close === 'function') b.close(); };

async function docAnh(file) {
    if (typeof window.createImageBitmap === 'function') {
        try { return await window.createImageBitmap(file, { imageOrientation: 'from-image' }); }
        catch (e) {
            try { return await window.createImageBitmap(file); } catch (e2) { /* thử cách dưới */ }
        }
    }
    return await new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
        img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
        img.src = url;
    });
}

const veRa = (nguon, w, h, kieu, chatLuong) => new Promise((resolve) => {
    try {
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) return resolve(null);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        if (kieu === 'image/jpeg') { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); }   // PNG trong suốt không bị đen
        ctx.drawImage(nguon, 0, 0, w, h);
        canvas.toBlob((b) => resolve(b), kieu, chatLuong);
    } catch (e) { resolve(null); }
});

const tenMoi = (file, duoi) => (String(file.name || 'anh').replace(/\.[^.]+$/, '') || 'anh') + duoi;

/**
 * Chuẩn bị ảnh đại diện. Trả { goc: File, nho: File|null, rong, cao, giuNguyenTep }
 * Không bao giờ ném lỗi: không xử lý được thì trả tệp gốc nguyên vẹn, không có bản nhỏ.
 */
export async function taoAnhDaiDien(file) {
    const ketQuaTho = { goc: file, nho: null, rong: null, cao: null, giuNguyenTep: true };
    if (!file || !/^image\//i.test(file.type)) return ketQuaTho;
    let anh = null;
    try {
        anh = await docAnh(file);
        const w0 = anh.width, h0 = anh.height;
        if (!w0 || !h0) { dongLai(anh); return ketQuaTho; }

        // Bản nhỏ cho chỗ hiện bé
        const tiLeNho = Math.min(1, CANH_NHO / Math.max(w0, h0));
        const blobNho = await veRa(anh, Math.max(1, Math.round(w0 * tiLeNho)), Math.max(1, Math.round(h0 * tiLeNho)), 'image/jpeg', CHAT_LUONG_NHO);
        const nho = blobNho ? new File([blobNho], tenMoi(file, '_nho.jpg'), { type: 'image/jpeg', lastModified: Date.now() }) : null;

        // GIF giữ nguyên tệp (vẽ lại là mất chuyển động)
        if (/image\/gif/i.test(file.type)) { dongLai(anh); return { goc: file, nho, rong: w0, cao: h0, giuNguyenTep: true }; }

        // Bản gốc: giữ nguyên độ phân giải; chỉ thu khi vượt sức vẽ của trình duyệt
        const tiLe = w0 * h0 > DIEM_TOI_DA ? Math.sqrt(DIEM_TOI_DA / (w0 * h0)) : 1;
        const w = Math.max(1, Math.floor(w0 * tiLe)), h = Math.max(1, Math.floor(h0 * tiLe));
        const laPng = /image\/png/i.test(file.type);
        const blobGoc = await veRa(anh, w, h, laPng ? 'image/png' : 'image/jpeg', laPng ? undefined : CHAT_LUONG_GOC);
        dongLai(anh);
        if (!blobGoc) return { goc: file, nho, rong: w0, cao: h0, giuNguyenTep: true };
        const goc = new File([blobGoc], tenMoi(file, laPng ? '.png' : '.jpg'), { type: laPng ? 'image/png' : 'image/jpeg', lastModified: Date.now() });
        return { goc, nho, rong: w, cao: h, giuNguyenTep: false };
    } catch (e) {
        dongLai(anh);
        return ketQuaTho;
    }
}
